"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeStylesAccessible = exports.BadgeStyles = void 0;
var tokensNormal = __importStar(require("@iqmetrix/style-tokens/dist/js/tokens"));
var tokensAccessibility = __importStar(require("@iqmetrix/style-tokens/dist/js/tokens-accessibility"));
var getBadgeStyles = function (withAccessibility) {
    if (withAccessibility === void 0) { withAccessibility = false; }
    var tokens = withAccessibility ? tokensAccessibility : tokensNormal;
    var BadgeStyles = {
        Success: {
            backgroundColor: tokens.ColorBadgeSuccessBackground,
            color: tokens.ColorBadgeSuccessText,
        },
        Error: {
            backgroundColor: tokens.ColorBadgeErrorBackground,
            color: tokens.ColorBadgeErrorText,
        },
        Information: {
            backgroundColor: tokens.ColorBadgeInformationBackground,
            color: tokens.ColorBadgeInformationText,
        },
        Default: {
            backgroundColor: tokens.ColorBadgeDefaultBackground,
            color: tokens.ColorBadgeDefaultText,
        },
        Warning: {
            backgroundColor: tokens.ColorBadgeNonCriticalWarningBackground,
            color: tokens.ColorBadgeNonCriticalWarningText,
        },
        CriticalWarning: {
            backgroundColor: tokens.ColorBadgeCriticalWarningBackground,
            color: tokens.ColorBadgeCriticalWarningText,
        },
    };
    return BadgeStyles;
};
exports.BadgeStyles = getBadgeStyles();
exports.BadgeStylesAccessible = getBadgeStyles(true);
exports.default = exports.BadgeStyles;
//# sourceMappingURL=index.js.map